import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { CommonService } from 'src/app/service/common.service';
import { MqttService } from 'src/app/service/mqtt.service';

@Component({
  selector: 'app-setting',
  templateUrl: './setting.component.html',
  styleUrls: ['./setting.component.css']
})
export class SettingComponent implements OnInit {

  constructor(public cm:CommonService,private route: ActivatedRoute,public mqtt:MqttService) { }

  profile = {
    name:'',
    uuid:'',
    province : '',
    area : '',
    lat:'',
    lon:'',
    line_group_name:'',
    line_unit_text:'',
    Line_send_freq:'',
    line_token:'',
    line_show_time:''
  }

  database;
  ngOnInit() {
    this.route.url.subscribe((data)=>{
      this.getInfomation(data[1]);
      this.getLastCal();
      this.mqtt.connectMqtt(this.cm.getConfig().mqtt_username,this.cm.getConfig().mqtt_password,[this.profile]);
    })
  }

  ngOnDestroy(){
    console.log('destroy');
    this.mqtt.disconnect();
  }

  getInfomation(uuid){
    const api = "/v1.0/devices/"+uuid;
    this.cm.getHtpp(api,'').then((data:any)=>{
      this.database = data;
      this.profile.name = data.name;
      this.profile.uuid = data.uuid;
      // check have attr
      if(data.attribute){
        this.profile.province         = data.attribute.province;
        this.profile.area             = data.attribute.area;
        this.profile.lat              = data.attribute.lat;
        this.profile.lon              = data.attribute.lon;
        this.profile.line_group_name  = data.attribute.line_group_name;
        this.profile.line_unit_text   = data.attribute.line_unit_text;
        this.profile.Line_send_freq   = data.attribute.Line_send_freq;
        this.profile.line_token       = data.attribute.line_token;
        this.profile.line_show_time   = data.attribute.line_show_time;
      }
      

      console.log(data);
      
    })

  }

  save(){
    console.log(this.profile);
    const api = '/v1.0/devices/'+this.profile.uuid;
    const body = {
      "name":this.profile.name,
      "attribute": this.profile
    }
    this.cm.putHtpp(api,body,'').then((data)=>{
      console.log(data);
      this.cm.toastr.success('บันทึกข้อมูลสำเร็จ','สำเร็จ');
    }).catch((error)=>{
      console.log(error);
      this.cm.toastr.warning('ชื่อผู้ใช้งานหรือรหัสผ่านไม่ถูกต้อง','แจ้งเตือน');
    })
  }

  back(){
    this.cm.goto('/dashboard');
  }

  sendSettingMath(slope,contant,offset){
    console.log(this.profile.uuid);
    
    this.mqtt.pub('channel/'+this.profile.uuid+'/water_cal_slope',slope);
    this.mqtt.pub('channel/'+this.profile.uuid+'/water_cal_constant',contant);
    this.mqtt.pub('channel/'+this.profile.uuid+'/water_cal_offset',offset);
  }

  getLastCal(){
    const api = '/v1.0/analytic/getHistoryByDevice?uuid='+this.profile.uuid+'&channels=water_cal_slope,water_cal_constant,water_cal_offset&limit=1'
    console.log(api);
    
    this.cm.getHtpp(api,'').then((data)=>{
      console.log(data);
      
    })
  }

}
